@if (!hidden) {
    <div class="menuItemWrapper" [class.active]="active === true">
        <div class="menuItem"
             [class.active]="active === true"
             [class.firstItem]="first === true"
             (click)="click()">
            @if (!menupoint.icon) {
                <div class="icon {{ menupoint.name }}"></div>
            } @else {
                <!-- Fuer Icons die nicht in der VHV Icon Font enthalten sind -->
                <div class="vhvicon vhvicon-{{menupoint.icon}}">
                    @if (menupoint.name === 'posteingang' && nachrichtenAnzahl > 0) {
                        <div class="circle">{{ nachrichtenAnzahl }}</div>
                    }
                </div>
            }
            <div class="label">
          <span>
            {{ menupoint.label }}
          </span>
            </div>
            <div class="arrow">&#160;</div>
        </div>
        @if (active === true && menupoint.children.length !== 0) {
            <div class="subMenuItemWrapper">
                <!-- bei defektem Datensatz: zusätzlich bei .subMenuItem die Klasse .defekt verwenden -->
                @for (submenuitem of menupoint.children; track submenuitem; let i = $index) {
                    <div
                        class="subMenuItem"
                        [class.defekt]="submenuitem.defekt"
                        [class.active]="submenuitem.targetUri === subPage"
                        (click)="subclick(i)">
                        <div class="ico-subMenuItem"></div>
                        <div class="label">{{ submenuitem.label | formatVsnr }}</div>
                        <div class="arrow"></div>
                    </div>
                }
            </div>
        }
    </div>
}

